/**
 * Rumah de Parfum — scroll reveal
 *
 * Fades content in as it enters the viewport, matching the pacing of the
 * existing site.
 *
 * Designed to fail open. The CSS only hides `.rdp-reveal` elements when
 * `.rdp-reveal-ready` is present on <html>, and this script is the only thing
 * that adds that class. So if JS is disabled, fails to parse, or the browser
 * lacks IntersectionObserver, content renders visible instead of invisible.
 * That ordering matters: the alternative — hiding by default and revealing with
 * JS — leaves the whole page blank when anything goes wrong.
 *
 * Honours prefers-reduced-motion by not engaging at all.
 */
(function () {
  "use strict";

  var root = document.documentElement;

  // Bail out entirely if the user prefers reduced motion, or the browser can't
  // observe intersections. In both cases content stays visible.
  if (
    !("IntersectionObserver" in window) ||
    window.matchMedia("(prefers-reduced-motion: reduce)").matches
  ) {
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("is-visible");
        // Reveal is one-way; stop watching once shown.
        observer.unobserve(entry.target);
      });
    },
    {
      // Trigger a little before the element is fully in view so the transition
      // has begun by the time it reads as "arrived".
      rootMargin: "0px 0px -8% 0px",

      // Deliberately 0, not a fraction. A ratio threshold is a trap here: an
      // element taller than the (margin-shrunk) viewport can never reach a high
      // intersection ratio, so anything like 0.05 would leave very tall
      // sections permanently hidden. Zero means "as soon as any part enters".
      threshold: 0,
    },
  );

  function observe(scope) {
    (scope || document)
      .querySelectorAll(".rdp-reveal:not(.is-visible)")
      .forEach(function (el) {
        observer.observe(el);
      });
  }

  function start() {
    // Only now does the CSS start hiding things.
    root.classList.add("rdp-reveal-ready");
    observe(document);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, { once: true });
  } else {
    start();
  }

  // Sections re-render as the merchant edits them in the theme editor, and
  // Horizon swaps content on navigation. Pick up anything new.
  document.addEventListener("shopify:section:load", function (event) {
    observe(event.target);
  });

  document.addEventListener("shopify:section:reorder", function () {
    observe(document);
  });
})();
